export default function ReportsPrintPayloadReplacer(Utils) {
  'ngInject';

  function _isEventObjectWithTimesheets(obj) {
    return 'clockedIn' in obj;
  }

  function _isDate(obj, prop) {
    return (
      (prop === 'clockedIn' || prop === 'clockedOut' || prop === 'dtstart' || prop === 'dtend') &&
      obj[prop] &&
      'dtstart' in obj
    ); // make sure it's an event obj
  }

  function _stringifyDate(d) {
    return d ? `${Utils.formatDate(d)}T${Utils.formatTime(d, false, true)}:00` : '';
  }

  const TIMESHEETS_RELEVANT_EVENT_PROPS = [
    'dtstart',
    'dtend',
    'user',
    'location',
    'position',
    'tags',
    'clockedIn',
    'clockedOut',
    'duration',
    'actualBreakDuration',
    'actualBreakMinutes',
    'actualDuration',
    'realMinutes',
    'paidDurationMinutes',
    'scheduledMinutes',
    'actualDifference',
    'differenceMinutes',
    'timesheetStatus',
    'breakDuration',
    'timesheetProjections',
    'fromIntegration',
    'clockedInArray',
    'clockedOutArray',
    'breakStartArray',
    'breakEndArray',
    'breakDurationArray',
    'actualDurationArray',
    'isAutoClockOutArray',
    'breakTypeArray',
    'scheduledBreakDurationArray',
  ];

  // eslint-disable-next-line complexity
  return function reportsPrintPayloadReplacer(key, value) {
    // event with timesheets
    if (_isEventObjectWithTimesheets(this)) {
      if (!TIMESHEETS_RELEVANT_EVENT_PROPS.includes(key)) {
        return undefined;
      }

      if (key === 'timesheetProjections') {
        return this.timesheetProjections.map(
          ({
            clockInDistanceFromLocation,
            clockOutDistanceFromLocation,
            clockIn,
            clockOut,
            paidMinutes,
            breakMinutes,
          }) => ({
            clockInDistanceFromLocation,
            clockOutDistanceFromLocation,
            clockIn: _stringifyDate(clockIn),
            clockOut: _stringifyDate(clockOut),
            paidMinutes,
            breakMinutes,
          })
        );
      }
    }

    if (['location', 'position', 'user'].includes(key) && value) {
      const redacted = {
        id: value.id,
        name: value.name,
      };

      if (key === 'position' || key === 'location') {
        redacted.externalId = value.externalId;
      }

      if (key === 'position') {
        redacted.color = value.color;
      }

      if (key === 'user') {
        redacted.fullname = value.fullname;
        redacted.fullLegalName = value.fullLegalName;
        redacted.name = value.name;
        redacted.lastname = value.lastname;
        redacted.employeeId = value.employeeId;
        redacted.groups = value.groups;
      }

      return redacted;
    }

    if (_isDate(this, key)) {
      return _stringifyDate(this[key]);
    }

    return value;
  };
}
